const CITIES = {
  "Chicago": [
    { origin: "Millennium Park, Chicago", destination: "Lincoln Park Zoo, Chicago" },
    { origin: "Wrigley Field, Chicago", destination: "Navy Pier, Chicago" },
    { origin: "O'Hare Airport, Chicago", destination: "Willis Tower, Chicago" },
    { origin: "The Bean, Chicago", destination: "Shedd Aquarium, Chicago" },
    { origin: "Soldier Field, Chicago", destination: "Wrigley Field, Chicago" },
    { origin: "Art Institute of Chicago, Chicago", destination: "Museum of Science and Industry, Chicago" },
    { origin: "Navy Pier, Chicago", destination: "Wicker Park, Chicago" },
    { origin: "Midway Airport, Chicago", destination: "Magnificent Mile, Chicago" },
    { origin: "United Center, Chicago", destination: "Grant Park, Chicago" },
    { origin: "Guaranteed Rate Field, Chicago", destination: "The Bean, Chicago" },
    { origin: "Field Museum, Chicago", destination: "Logan Square, Chicago" },
    { origin: "Lincoln Park Zoo, Chicago", destination: "Hyde Park, Chicago" },
    { origin: "Adler Planetarium, Chicago", destination: "O'Hare Airport, Chicago" },
    { origin: "Wicker Park, Chicago", destination: "Museum Campus, Chicago" },
    { origin: "Willis Tower, Chicago", destination: "Brookfield Zoo, Chicago" },
    { origin: "Hyde Park, Chicago", destination: "Navy Pier, Chicago" },
    { origin: "Riverwalk, Chicago", destination: "Humboldt Park, Chicago" },
    { origin: "Magnificent Mile, Chicago", destination: "Guaranteed Rate Field, Chicago" },
    { origin: "Logan Square, Chicago", destination: "Soldier Field, Chicago" },
    { origin: "Midway Airport, Chicago", destination: "Lincoln Park Zoo, Chicago" },
    { origin: "Art Institute of Chicago, Chicago", destination: "United Center, Chicago" },
    { origin: "Brookfield Zoo, Brookfield IL", destination: "Willis Tower, Chicago" },
    { origin: "Museum of Science and Industry, Chicago", destination: "Wrigley Field, Chicago" },
    { origin: "Humboldt Park, Chicago", destination: "Shedd Aquarium, Chicago" },
    { origin: "Grant Park, Chicago", destination: "O'Hare Airport, Chicago" },
    { origin: "The Bean, Chicago", destination: "Midway Airport, Chicago" },
    { origin: "Field Museum, Chicago", destination: "Wicker Park, Chicago" },
    { origin: "Adler Planetarium, Chicago", destination: "United Center, Chicago" },
    { origin: "Navy Pier, Chicago", destination: "Brookfield Zoo, Brookfield IL" },
    { origin: "Hyde Park, Chicago", destination: "Logan Square, Chicago" },
  ],
"New York": [
  { origin: "Times Square, New York", destination: "Central Park, New York" },
  { origin: "Brooklyn Bridge, New York", destination: "Yankee Stadium, New York" },
  { origin: "JFK Airport, New York", destination: "Statue of Liberty Ferry Terminal, New York" },
  { origin: "Grand Central Terminal, New York", destination: "Coney Island, New York" },
  { origin: "Times Square, New York", destination: "Brooklyn Bridge, New York" },
  { origin: "Central Park, New York", destination: "Flushing Meadows Corona Park, New York" },
  { origin: "LaGuardia Airport, New York", destination: "Times Square, New York" },
  { origin: "JFK Airport, New York", destination: "Grand Central Terminal, New York" },
  { origin: "Yankee Stadium, New York", destination: "Citi Field, New York" },
  { origin: "Columbia University, New York", destination: "New York University, New York" },
  { origin: "Brooklyn Museum, New York", destination: "The Met, New York" },
  { origin: "Statue of Liberty Ferry Terminal, New York", destination: "Grand Central Terminal, New York" },
  { origin: "Penn Station, New York", destination: "Coney Island, New York" },
  { origin: "Central Park, New York", destination: "Williamsburg, Brooklyn, New York" },
  { origin: "Times Square, New York", destination: "JFK Airport, New York" },
  { origin: "Newark Airport, New Jersey", destination: "Times Square, New York" },
  { origin: "Grand Central Terminal, New York", destination: "Yankee Stadium, New York" },
  { origin: "Wall Street, New York", destination: "Columbia University, New York" },
  { origin: "Astoria, Queens, New York", destination: "Brooklyn Bridge, New York" },
  { origin: "High Line, New York", destination: "Flushing Meadows Corona Park, New York" },
  { origin: "Times Square, New York", destination: "LaGuardia Airport, New York" },
  { origin: "Coney Island, New York", destination: "Yankee Stadium, New York" },
  { origin: "JFK Airport, New York", destination: "Columbia University, New York" },
  { origin: "Brooklyn Bridge, New York", destination: "Central Park, New York" },
  { origin: "Penn Station, New York", destination: "LaGuardia Airport, New York" },
  { origin: "The Met, New York", destination: "Brooklyn Museum, New York" },
  { origin: "Williamsburg, Brooklyn, New York", destination: "Times Square, New York" },
  { origin: "Newark Airport, New Jersey", destination: "JFK Airport, New York" },
  { origin: "Citi Field, New York", destination: "Wall Street, New York" },
  { origin: "High Line, New York", destination: "Yankee Stadium, New York" },
],
  
  "Los Angeles": [
    { origin: "Santa Monica Pier, Los Angeles", destination: "Griffith Observatory, Los Angeles" },
    { origin: "LAX Airport, Los Angeles", destination: "Hollywood Sign, Los Angeles" },
    { origin: "Dodger Stadium, Los Angeles", destination: "Venice Beach, Los Angeles" },
  ],
  "San Francisco": [
    { origin: "Golden Gate Bridge, San Francisco", destination: "Fisherman's Wharf, San Francisco" },
    { origin: "Alcatraz Ferry Terminal, San Francisco", destination: "Oracle Park, San Francisco" },
    { origin: "SFO Airport, San Francisco", destination: "Union Square, San Francisco" },
  ],
  "San Diego": [
    { origin: "Balboa Park, San Diego", destination: "USS Midway Museum, San Diego" },
    { origin: "San Diego Zoo, San Diego", destination: "Coronado Beach, San Diego" },
    { origin: "Petco Park, San Diego", destination: "La Jolla Cove, San Diego" },
  ],
  "Houston": [
    { origin: "Space Center Houston, Houston", destination: "Houston Zoo, Houston" },
    { origin: "Minute Maid Park, Houston", destination: "Galleria Mall, Houston" },
    { origin: "George Bush Airport, Houston", destination: "Museum of Fine Arts, Houston" },
  ],
  "Philadelphia": [
    { origin: "Liberty Bell, Philadelphia", destination: "Philadelphia Museum of Art, Philadelphia" },
    { origin: "Citizens Bank Park, Philadelphia", destination: "Reading Terminal Market, Philadelphia" },
    { origin: "Philadelphia Airport, Philadelphia", destination: "Independence Hall, Philadelphia" },
  ],
  "Washington DC": [
    { origin: "Lincoln Memorial, Washington DC", destination: "US Capitol, Washington DC" },
    { origin: "Smithsonian National Zoo, Washington DC", destination: "Arlington Cemetery, Washington DC" },
    { origin: "Dulles Airport, Washington DC", destination: "White House, Washington DC" },
  ],
  "Boston": [
    { origin: "Fenway Park, Boston", destination: "Freedom Trail, Boston" },
    { origin: "Harvard University, Cambridge MA", destination: "Boston Harbor, Boston" },
    { origin: "Logan Airport, Boston", destination: "Faneuil Hall, Boston" },
  ],
  "Miami": [
    { origin: "South Beach, Miami", destination: "Wynwood Walls, Miami" },
    { origin: "Marlins Park, Miami", destination: "Vizcaya Museum, Miami" },
    { origin: "Miami Airport, Miami", destination: "Art Deco Historic District, Miami Beach" },
  ],
  "St Croix, USVI": [
    { origin: "Leatherback Brewing Co, St Croix", destination: "Frederiksted Pier, St Croix" },
    { origin: "Leatherback Brewing Co, St Croix", destination: "Christiansted Boardwalk, St Croix" },
    { origin: "Leatherback Brewing Co, St Croix", destination: "Cane Bay, St Croix" },
    { origin: "Leatherback Brewing Co, St Croix", destination: "Point Udall, St Croix" },
    { origin: "Frederiksted Pier, St Croix", destination: "Christiansted Boardwalk, St Croix" },
    { origin: "Frederiksted Pier, St Croix", destination: "Cane Bay, St Croix" },
    { origin: "Frederiksted Pier, St Croix", destination: "Point Udall, St Croix" },
    { origin: "Christiansted Boardwalk, St Croix", destination: "Cane Bay, St Croix" },
    { origin: "Christiansted Boardwalk, St Croix", destination: "Point Udall, St Croix" },
    { origin: "Ziggy's, St Croix", destination: "Cheeseburgers in Paradise, St Croix" },
  ],

  "Geneva": [
    { origin: "Geneva Airport, Geneva", destination: "Old Town Geneva, Geneva" },
    { origin: "CERN, Meyrin", destination: "Jet d'Eau, Geneva" },
    { origin: "Palais des Nations, Geneva", destination: "Carouge, Geneva" },
    { origin: "Geneva Train Station, Geneva", destination: "Parc des Bastions, Geneva" },
    { origin: "Jet d'Eau, Geneva", destination: "Geneva Airport, Geneva" },
    { origin: "Museum of Art and History, Geneva", destination: "CERN, Meyrin" },
    { origin: "Carouge, Geneva", destination: "Palais des Nations, Geneva" },
    { origin: "Parc La Grange, Geneva", destination: "Geneva Train Station, Geneva" },
    { origin: "Plainpalais, Geneva", destination: "Old Town Geneva, Geneva" },
    { origin: "Geneva Airport, Geneva", destination: "Palais des Nations, Geneva" },
    { origin: "Geneva Graduate Institute, Geneva", destination: "Plaine de Plainpalais, Geneva" },
  ],
  "Lausanne": [
    { origin: "Lausanne Train Station, Lausanne", destination: "Olympic Museum, Lausanne" },
    { origin: "EPFL, Lausanne", destination: "Lausanne Cathedral, Lausanne" },
    { origin: "Ouchy, Lausanne", destination: "Flon, Lausanne" },
    { origin: "Lausanne Airport, Lausanne", destination: "Olympic Museum, Lausanne" },
    { origin: "Lausanne Cathedral, Lausanne", destination: "EPFL, Lausanne" },
    { origin: "Signal de Sauvabelin, Lausanne", destination: "Ouchy, Lausanne" },
    { origin: "Flon, Lausanne", destination: "Lausanne Train Station, Lausanne" },
    { origin: "Olympic Museum, Lausanne", destination: "Signal de Sauvabelin, Lausanne" },
    { origin: "Lausanne Train Station, Lausanne", destination: "Vidy, Lausanne" },
    { origin: "Vidy, Lausanne", destination: "Lausanne Cathedral, Lausanne" },
  ],
  "Bern": [
    { origin: "Bern Train Station, Bern", destination: "Bear Park, Bern" },
    { origin: "Bern Airport, Bern", destination: "Zytglogge, Bern" },
    { origin: "Rose Garden, Bern", destination: "Federal Palace, Bern" },
    { origin: "Federal Palace, Bern", destination: "Bern Train Station, Bern" },
    { origin: "Zytglogge, Bern", destination: "Rose Garden, Bern" },
    { origin: "Bern Train Station, Bern", destination: "Bern Airport, Bern" },
    { origin: "Bear Park, Bern", destination: "Bern Historical Museum, Bern" },
    { origin: "Bern Historical Museum, Bern", destination: "Federal Palace, Bern" },
    { origin: "Gurten, Bern", destination: "Bern Train Station, Bern" },
    { origin: "Bern Airport, Bern", destination: "Rose Garden, Bern" },
  ],
  "Zurich": [
    { origin: "Zurich Airport, Zurich", destination: "Old Town Zurich, Zurich" },
    { origin: "ETH Zurich, Zurich", destination: "Zurich Main Station, Zurich" },
    { origin: "Uetliberg, Zurich", destination: "Zurich Zoo, Zurich" },
    { origin: "Zurich Main Station, Zurich", destination: "Zurich Airport, Zurich" },
    { origin: "Zurich Zoo, Zurich", destination: "ETH Zurich, Zurich" },
    { origin: "Kunsthaus Zurich, Zurich", destination: "Uetliberg, Zurich" },
    { origin: "Zurich Main Station, Zurich", destination: "Kunsthaus Zurich, Zurich" },
    { origin: "Old Town Zurich, Zurich", destination: "Zurich Zoo, Zurich" },
    { origin: "Zurich Airport, Zurich", destination: "ETH Zurich, Zurich" },
    { origin: "Lindt Home of Chocolate, Kilchberg", destination: "Zurich Main Station, Zurich" },
  ],
  "Basel": [
    { origin: "Basel Airport, Basel", destination: "Basel Minster, Basel" },
    { origin: "Art Basel Hall, Basel", destination: "Basel Train Station, Basel" },
    { origin: "Zoo Basel, Basel", destination: "Tinguely Museum, Basel" },
    { origin: "Basel Train Station, Basel", destination: "Zoo Basel, Basel" },
    { origin: "Basel Minster, Basel", destination: "Art Basel Hall, Basel" },
    { origin: "Tinguely Museum, Basel", destination: "Basel Airport, Basel" },
    { origin: "Basel Train Station, Basel", destination: "Basel Minster, Basel" },
    { origin: "Basel Airport, Basel", destination: "Zoo Basel, Basel" },
    { origin: "Kunstmuseum Basel, Basel", destination: "Basel Train Station, Basel" },
    { origin: "Basel Train Station, Basel", destination: "Kunstmuseum Basel, Basel" },
  ],
};



export default CITIES;